import { isAdminUser, markStaffTraffic } from '@/utils/staffTraffic'

export default ({ app }) => {
  if (!process.client) return

  const apply = () => {
    if (isAdminUser(app.$auth)) markStaffTraffic()
  }

  apply()
  app.$auth?.$storage?.watchState?.('loggedIn', apply)
}
